// extracted by mini-css-extract-plugin
export default {"outlet":"plans_outlet__Jdti6","title":"plans_title__qtjHe","itemIcon":"plans_itemIcon__-U+fI","tableActions":"plans_tableActions__06CYO"};